export const ROUNDED = {
    NONE: 'rounded-none',
    SM: 'rounded-sm',
    DEFAULT: 'rounded',
    MD: 'rounded-md',
    LG: 'rounded-lg',
    XL: 'rounded-xl',
    FULL: 'rounded-full'
};

export const SHADOW = {
    NONE: 'shadow-none',
    SM: 'shadow-sm',
    DEFAULT: 'shadow',
    MD: 'shadow-md',
    LG: 'shadow-lg',
    XL: 'shadow-xl'
};

export const CARD = {
    DEFAULT: 'rounded-md shadow-md',
    ELEVATED: 'rounded-lg shadow-lg',
    FLAT: 'rounded-md shadow-none',
    OUTLINED: 'rounded-md border border-gray-200'
};

export const GRID = {
    COL_SPAN: {
        FULL: 'col-span-full',
        HALF: 'col-span-2',
        THIRD: 'col-span-1'
    }
};

export const LAYOUT = {
    MIN_HEIGHT: {
        SM: 'min-h-[100px]',
        MD: 'min-h-[250px]',
        LG: 'min-h-[400px]'
    }
}; 